// ── Theme colours ─────────────────────────────────────────────────────────────
export const M  = '#7a0000';
export const ML = '#b71c1c';
export const G  = '#FFD700';
export const BG = '#f4f6fa';

// ── INR → foreign currency approximate conversion ────────────────────────────
export const APPROX_RATES = {
  US:'USD', GB:'GBP', AE:'AED', CA:'CAD', AU:'AUD', NZ:'NZD', SG:'SGD',
  MY:'MYR', QA:'QAR', KW:'KWD', BH:'BHD', SA:'SAR', OM:'OMR', DE:'EUR', FR:'EUR', IT:'EUR',
  NL:'EUR', SE:'SEK', NO:'NOK', DK:'DKK', CH:'CHF', JP:'JPY', ZA:'ZAR', KE:'KES', MU:'MUR',
};

export const INR_TO = {
  USD:0.012, GBP:0.0095, AED:0.044, CAD:0.016, AUD:0.018, NZD:0.020,
  SGD:0.016, MYR:0.056, QAR:0.044, KWD:0.0037, BHD:0.0046, SAR:0.045, OMR:0.0047,
  EUR:0.011, SEK:0.13, NOK:0.13, DKK:0.082, CHF:0.011, JPY:1.82, ZAR:0.22, KES:1.56, MUR:0.56,
};

// ── Country → ISO code mapping ────────────────────────────────────────────────
export const COUNTRY_ISO = {
  'india':'IN', 'भारत':'IN', 'usa':'US', 'united states':'US', 'america':'US',
  'uk':'GB', 'united kingdom':'GB', 'england':'GB', 'britain':'GB',
  'uae':'AE', 'dubai':'AE', 'abu dhabi':'AE', 'united arab emirates':'AE',
  'canada':'CA', 'australia':'AU', 'new zealand':'NZ', 'singapore':'SG',
  'malaysia':'MY', 'nepal':'NP', 'sri lanka':'LK', 'pakistan':'PK',
  'germany':'DE', 'france':'FR', 'italy':'IT', 'netherlands':'NL',
  'sweden':'SE', 'norway':'NO', 'denmark':'DK', 'switzerland':'CH',
  'qatar':'QA', 'kuwait':'KW', 'bahrain':'BH', 'saudi arabia':'SA', 'oman':'OM',
  'south africa':'ZA', 'kenya':'KE', 'mauritius':'MU', 'fiji':'FJ',
  'japan':'JP', 'china':'CN', 'hong kong':'HK', 'south korea':'KR',
};
